import { AppBar, Avatar, Box, Button, CircularProgress, Toolbar, Typography } from '@mui/material';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider.js';
import { SCRIPTPAD_LOGO_URL, colors } from '@scriptpad/shared';

export const ProtectedLayout = () => {
  const { admin, loading, logout } = useAuth();
  const navigate = useNavigate();

  // Only redirect once we're certain there's no session - never mid-bootstrap,
  // otherwise reloading on a protected page flashes /login while the refresh
  // token is being exchanged.
  if (!loading && !admin) return <Navigate to="/login" replace />;

  const initial = admin?.name?.[0]?.toUpperCase() ?? admin?.email?.[0]?.toUpperCase() ?? '';

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: colors.bgWash }}>
      <AppBar position="sticky" color="inherit" elevation={0} sx={{ borderBottom: `1px solid ${colors.border}` }}>
        <Toolbar sx={{ gap: 2 }}>
          <Box
            component="img"
            src={SCRIPTPAD_LOGO_URL}
            alt="ScriptPad"
            sx={{ height: 28, cursor: admin ? 'pointer' : 'default' }}
            onClick={() => admin && navigate('/onboardings')}
          />
          <Typography variant="subtitle2" sx={{ color: colors.lightGrey }}>
            Onboarding Admin
          </Typography>
          <Box sx={{ flex: 1 }} />
          {admin && (
            <>
              <Avatar sx={{ width: 32, height: 32, bgcolor: colors.primary, fontSize: 14 }}>{initial}</Avatar>
              <Typography variant="body2">{admin.name}</Typography>
              <Button onClick={() => logout().then(() => navigate('/login'))}>Sign out</Button>
            </>
          )}
        </Toolbar>
      </AppBar>
      <Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: 1280, mx: 'auto' }}>
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '60vh',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Outlet />
        )}
      </Box>
    </Box>
  );
};
